// extracted by mini-css-extract-plugin
module.exports = {"map":"styles_map__D8Ri7","absolute":"styles_absolute__3mmxo","withFooter":"styles_withFooter__3LisH"};